import React, { useCallback } from 'react';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router';

import Tr from '../../../../../../components/common-table/components/Tr';
import Td from '../../../../../../components/common-table/components/Td';
import Icon from '../../../../../../icons/Icon';
import { ICONS } from '../../../../../../icons';
import ColoredName from './ColoredName';
import StatusCell from './StatusCell';

import scss from '../WritersList.module.scss';

const WritersTableItem = ({ writer = {}, rowRank, onDelete }) => {
  const navigate = useNavigate();
  const { id, writerName, writerColor, writerPhrase, status, updatedBy, updatedOn } = writer;

  const handleEditWriter = useCallback(() => {
    navigate(`edit-writer/${id}`);
  }, [navigate, id]);

  const handleDelete = useCallback(() => {
    onDelete(writer);
  }, [onDelete, writer]);

  return (
    <Tr extraClasses={scss.tr}>
      <Td extraClasses='cell-rank'>{rowRank}</Td>
      <Td extraClasses={scss.cellName} isLeft>
        <ColoredName color={writerColor} name={writerName} />
      </Td>
      <Td isLeft extraClasses={scss.cellPhrase}>
        <span>{writerPhrase}</span>
      </Td>
      <Td extraClasses={scss.cell150} isLeft>
        <StatusCell status={status} />
      </Td>
      <Td extraClasses={scss.cell150} isLeft>
        {updatedOn}
      </Td>
      <Td extraClasses={scss.cell220} isLeft>
        {updatedBy}
      </Td>
      <Td extraClasses={scss.cellAction} isLeft>
        <IconButton onClick={handleEditWriter} color='inherit' classes={{ root: scss.iconButton }}>
          <Icon icon={ICONS.Edit} disableCommonColors className={scss.fillIcon} />
        </IconButton>

        <IconButton onClick={handleDelete} color='inherit' classes={{ root: scss.iconButton }}>
          <Icon icon={ICONS.Delete} disableCommonColors className={scss.fillIcon} />
        </IconButton>
      </Td>
    </Tr>
  );
};

export default WritersTableItem;
